import { HydrateAction, hydrateType } from '../HydrateAction';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SettingsState, StateSettings } from './SettingsState';

const initialState: SettingsState = {
  settings: null
};

export interface SetSettingsPayload {
  readonly settings: StateSettings | null;
}

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<SetSettingsPayload>) => {
      state.settings = action.payload.settings;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrateType, (state, action: HydrateAction) => {
        if (action.payload.settings) {
          state.settings = action.payload.settings.settings;
        }
      })
      .addDefaultCase(() => {});
  }
});

export const { setSettings } = settingsSlice.actions;

export default settingsSlice.reducer;
